module.exports = __webpack_public_path__ + "static/img/why-3.ab02b8e7.jpg";